module.exports = __webpack_public_path__ + "img/3.3b781fcf.png";